"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionTypeDesc = exports.questionTypeTitle = exports.questionTypeLabel = exports.AllFormQuestionTypes = exports.FormQuestionType = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
// eslint-disable-next-line no-shadow
var FormQuestionType;
(function (FormQuestionType) {
    FormQuestionType["CHECK"] = "check";
    FormQuestionType["NUMBER"] = "number";
    FormQuestionType["TEXT"] = "text";
    FormQuestionType["LIST"] = "list";
    FormQuestionType["RATING"] = "rating";
    FormQuestionType["DATETIME"] = "datetime";
    FormQuestionType["PHOTO"] = "photo";
    FormQuestionType["SIGNATURE"] = "signature";
    FormQuestionType["SPT"] = "SPT";
    FormQuestionType["ASSET"] = "asset";
    FormQuestionType["INFO"] = "info";
    FormQuestionType["SECTION"] = "section";
    FormQuestionType["ISSUE"] = "issue";
    FormQuestionType["REPETITION"] = "repetition";
    FormQuestionType["QUESTIONSET"] = "questionset";
})(FormQuestionType = exports.FormQuestionType || (exports.FormQuestionType = {}));
exports.default = FormQuestionType;
exports.AllFormQuestionTypes = Object.values(FormQuestionType);
function questionTypeLabel(qt) {
    switch (qt) {
        case FormQuestionType.CHECK:
            return lib_i18n_1.default.t('type-check');
        case FormQuestionType.NUMBER:
            return lib_i18n_1.default.t('type-number');
        case FormQuestionType.TEXT:
            return lib_i18n_1.default.t('type-text');
        case FormQuestionType.LIST:
            return lib_i18n_1.default.t('type-list');
        case FormQuestionType.RATING:
            return lib_i18n_1.default.t('type-rating');
        case FormQuestionType.DATETIME:
            return lib_i18n_1.default.t('type-datetime');
        case FormQuestionType.PHOTO:
            return lib_i18n_1.default.t('type-photo');
        case FormQuestionType.SIGNATURE:
            return lib_i18n_1.default.t('type-signature');
        case FormQuestionType.SPT:
            return lib_i18n_1.default.t('type-spt');
        case FormQuestionType.ASSET:
            return lib_i18n_1.default.t('type-asset');
        case FormQuestionType.INFO:
            return lib_i18n_1.default.t('type-info');
        case FormQuestionType.SECTION:
            return lib_i18n_1.default.t('type-section');
        case FormQuestionType.ISSUE:
            return lib_i18n_1.default.t('type-issue');
        case FormQuestionType.REPETITION:
            return lib_i18n_1.default.t('type-repetition');
        case FormQuestionType.QUESTIONSET:
            return lib_i18n_1.default.t('type-questionset');
    }
}
exports.questionTypeLabel = questionTypeLabel;
function questionTypeTitle(qt) {
    switch (qt) {
        case FormQuestionType.CHECK:
            return lib_i18n_1.default.t('questiontype-check-title');
        case FormQuestionType.NUMBER:
            return lib_i18n_1.default.t('questiontype-number-title');
        case FormQuestionType.TEXT:
            return lib_i18n_1.default.t('questiontype-text-title');
        case FormQuestionType.LIST:
            return lib_i18n_1.default.t('questiontype-list-title');
        case FormQuestionType.RATING:
            return lib_i18n_1.default.t('questiontype-rating-title');
        case FormQuestionType.DATETIME:
            return lib_i18n_1.default.t('questiontype-datetime-title');
        case FormQuestionType.PHOTO:
            return lib_i18n_1.default.t('questiontype-photo-title');
        case FormQuestionType.SIGNATURE:
            return lib_i18n_1.default.t('questiontype-signature-title');
        case FormQuestionType.SPT:
            return lib_i18n_1.default.t('questiontype-spt-title');
        case FormQuestionType.ASSET:
            return lib_i18n_1.default.t('questiontype-asset-title');
        case FormQuestionType.INFO:
            return lib_i18n_1.default.t('questiontype-info-title');
        case FormQuestionType.SECTION:
            return lib_i18n_1.default.t('questiontype-section-title');
        case FormQuestionType.ISSUE:
            return lib_i18n_1.default.t('questiontype-issue-title');
        case FormQuestionType.REPETITION:
            return lib_i18n_1.default.t('questiontype-repetition-title');
        case FormQuestionType.QUESTIONSET:
            return lib_i18n_1.default.t('questiontype-questionset-title');
    }
}
exports.questionTypeTitle = questionTypeTitle;
function questionTypeDesc(qt) {
    switch (qt) {
        case FormQuestionType.CHECK:
            return lib_i18n_1.default.t('questiontype-check-desc');
        case FormQuestionType.NUMBER:
            return lib_i18n_1.default.t('questiontype-number-desc');
        case FormQuestionType.TEXT:
            return lib_i18n_1.default.t('questiontype-text-desc');
        case FormQuestionType.LIST:
            return lib_i18n_1.default.t('questiontype-list-desc');
        case FormQuestionType.RATING:
            return lib_i18n_1.default.t('questiontype-rating-desc');
        case FormQuestionType.DATETIME:
            return lib_i18n_1.default.t('questiontype-datetime-desc');
        case FormQuestionType.PHOTO:
            return lib_i18n_1.default.t('questiontype-photo-desc');
        case FormQuestionType.SIGNATURE:
            return lib_i18n_1.default.t('questiontype-signature-desc');
        case FormQuestionType.SPT:
            return lib_i18n_1.default.t('questiontype-spt-desc');
        case FormQuestionType.ASSET:
            return lib_i18n_1.default.t('questiontype-asset-desc');
        case FormQuestionType.INFO:
            return lib_i18n_1.default.t('questiontype-info-desc');
        case FormQuestionType.SECTION:
            return lib_i18n_1.default.t('questiontype-section-desc');
        case FormQuestionType.ISSUE:
            return lib_i18n_1.default.t('questiontype-issue-desc');
        case FormQuestionType.REPETITION:
            return lib_i18n_1.default.t('questiontype-repetition-desc');
        case FormQuestionType.QUESTIONSET:
            return lib_i18n_1.default.t('questiontype-questionset-desc');
    }
}
exports.questionTypeDesc = questionTypeDesc;
